import { mintDocsSession } from "@/api/auth";

/** Root of the docs portal on this origin (static Docusaurus behind nginx). */
export const DOCS_URL = "/docs/";

/**
 * Opens a docs-portal URL in a new tab, minting the `docs_access` cookie first
 * (TASK-4770; shared with the per-page portal links since TASK-5118).
 *
 * Must be called SYNCHRONOUSLY from the click handler: the tab is opened in the
 * same tick as the user's gesture (so a popup blocker never refuses it) and is
 * only navigated once the mint settles. No `noopener` feature string — by spec
 * it makes `window.open` return `null`, which would lose the handle; the opener
 * is severed by hand instead (same-origin target, so this is equivalent).
 *
 * Whatever the mint does, the user ends up at `url`; if a blocker really did
 * refuse the tab, the current tab navigates instead of swallowing the click.
 */
export function openDocsInNewTab(url: string = DOCS_URL): void {
  const tab = window.open("", "_blank");
  if (tab) {
    try {
      tab.opener = null;
    } catch {
      // Non-fatal: the target is same-origin, so this is defence in depth.
    }
  }

  const navigate = () => {
    if (tab) {
      tab.location.href = url;
    } else {
      window.location.href = url;
    }
  };

  // `void` + a catch-all: a failed mint must never surface as an unhandled
  // rejection or stop the navigation.
  void mintDocsSession().then(navigate, navigate);
}
